import featureToggles from 'shared/featureToggles'
import FormsyInput from '@components/Textfield/withFormsy'
import { nifRegex } from 'login-and-signup/validation'
import PhoneInput from './PhoneInput'

const UserDetails = ({ firstName, lastName, phone, email, translate: t }) => (
    <>
        <div className="row">
            <div className="col-md-6 mb-3">
                <FormsyInput
                    label={t('dashboard.account.firstname')}
                    validationError={t('dashboard.account.address1.invalid')}
                    name="firstName"
                    required
                    value={firstName}
                />
            </div>
            <div className="col-md-6 mb-3">
                <FormsyInput
                    value={lastName}
                    name="lastName"
                    required
                    label={t('dashboard.account.lastname')}
                    validationError={t('dashboard.account.lastName.invalid')}
                />
            </div>
        </div>
        <div className="row">
            <div className="col-md-6 mb-3">
                <FormsyInput
                    readOnly
                    disabled
                    value={email}
                    name="emailAddress"
                    validations="isEmail"
                    required
                    label={t('dashboard.account.email')}
                    validationError={t('dashboard.account.emailAddress.invalid')}
                />
            </div>
            <div className="col-md-6 mb-3">
                <PhoneInput value={phone} />
            </div>
        </div>
        {featureToggles.nifRequired && (
            <div className="row">
                <div className="col-md-6">
                    <FormsyInput
                        validations={{
                            matchRegexp: nifRegex,
                        }}
                        uppercase
                        name="custom1"
                        label={t('dashboard.account.nif')}
                        validationError={t('dashboard.account.nif.invalid')}
                    />
                </div>
            </div>
        )}
    </>
)

export default UserDetails
